import { html } from 'lit';
import componentStyles from './select.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class Select extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      options: { type: Array },
      placeholdertext: { type: String },
    }
  }

  constructor() {
    super()
    this.placeholdertext = ''
    this.options = []
  }

  render() {
    const content = html`
      <select class="select__button">
        <option value="" disabled selected>
          ${this.placeholdertext}
        </option>
        ${this.options.map(option => {
          return html`
            <option value="${option.value}">${option.text}</option>
          `
        })}
      </select>
    `
    return html`
      <div class="select__wrapper">${content}</div>`
  }
}

customElements.define('hf-select', Select)
